import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {OrderByPositionApiModel} from "./order-by-position.api-model";

export class OrderByPositionDomainModel extends BaseDomainModel {
  apiModel: OrderByPositionApiModel;

  get position(): String {
    return this.apiModel.position;
  }

  get positionOrder(): Number {
    return this.apiModel.positionOrder;
  }
}